import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "newsletter",
  "use": "newsletter-usage",
  "viewBox": "0 0 37.8 24.1",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 37.8 24.1\" id=\"newsletter\"><path d=\"M37.7 24.1H14.1V8.2h23.6v15.9zm-22-1.1H36l-4.9-7.7-5.2 5-5-4.8-5.2 7.5zm-.5-13v11.7l4.9-7-4.9-4.7zM32 14.5l4.5 7.1V10.1L32 14.5zM16.1 9.3l10 9.4 9.7-9.4H16.1zm-4.1 0H0V8.2h12v1.1zM37.7 5H6.4V3.9h31.3V5zm.1-3.9h-9.5V0h9.5v1.1z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol